<template>
  <hm-content title="">
    <div>
      <el-radio-group v-model="searchCondition.applyState" size="small"  @change="switchTabs">
        <el-radio-button label="all"
        >全部({{ stateNum.totalNum }})</el-radio-button
        >
        <el-radio-button label="wait"
        >待审核({{ stateNum.waitNum }})</el-radio-button
        >
        <el-radio-button label="agree"
        >同意({{ stateNum.agreeNum }})</el-radio-button
        >
        <el-radio-button label="refuse"
        >驳回({{ stateNum.refuseNum }})</el-radio-button
        >
      </el-radio-group>
    </div>
    <div class="flex flex-end item-center">
      <el-date-picker
          v-model="searchCondition.applyDate"
          type="daterange"
          range-separator="至"
          size="small"
          value-format="yyyy-MM-dd HH:mm:ss"
          class="mr10"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
      </el-date-picker>
      <el-input
          clearable
          v-model.trim="searchCondition.keyWord"
          placeholder="输入导购名称/电话"
          size="small"
          style="width: 222px"
          class="ipt mr20"
      ></el-input>
      <el-button type="primary"  size="small" @click="search"
      >查询</el-button
      >
    </div>
    <div class="mt20">
      <el-table
          stripe
          border
          ref="brandTable"
          :data="list"
          style="width: 100%"
          id="table"
          size="small"
      >
        <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="applyNo"
            label="申诉编号"
        >
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="idcardName"
            label="真实姓名"
        >
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="idcardNo"
            label="身份证号"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="guiderPhone"
            label="身份证正面"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-image
                  v-if="scope.row.applyIdcardFrontImg"
                  style="width: 100px; height: 100px"
                  :src="scope.row.applyIdcardFrontImg"
                  :preview-src-list="[scope.row.applyIdcardFrontImg]"
              >
              </el-image>
              <span v-else>未上传图片</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column
            header-align="center"
            align="center"
            prop="storeName"
            label="身份证反面"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-image
                  v-if="scope.row.applyIdcardBackImg"
                  style="width: 100px; height: 100px"
                  :src="scope.row.applyIdcardBackImg"
                  :preview-src-list="[scope.row.applyIdcardBackImg]"
              >
              </el-image>
              <span v-else>未上传图片</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="allowGetcashMoneyAmount"
            label="账户余额"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="authMobile"
            label="手机号"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="applyTime"
            label="申诉时间"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="applyState"
            label="申诉状态"
        >
          <template slot-scope="scope">
              <span class="success" v-if="scope.row.applyState === 'agree'"
              >同意</span
              >
              <span class="success" v-if="scope.row.applyState === 'running'"
              >同意</span
              >
              <span class="danger" v-if="scope.row.applyState === 'refuse'"
              >拒绝</span
              >
              <span class="blue" v-if="scope.row.applyState === 'wait'"
              >待审核</span
              >
          </template>
        </el-table-column>        
        <el-table-column
            header-align="center"
            align="center"
            prop="applyReason"
            label="注销原因"            
        >
          <template slot-scope="scope">
            <div class="danger">
              {{ scope.row.applyReason }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="refuseReason"
            label="驳回原因"
            v-if="searchCondition.applyState !== 'agree'"
        >
          <template slot-scope="scope">
            <div class="danger">
              {{ scope.row.applyResult }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="auditTime"
            label="审核时间"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="auditUsername"
            label="审核人"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="orderSn"
            label="操作"
            width="240"
            v-if="searchCondition.applyState === 'wait' || searchCondition.applyState === 'all'"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button
                  size="small"
                  type="text"
                  @click="audit(scope.row)"
                  v-if="scope.row.applyState === 'wait'"
              >同意</el-button
              >
              <el-button
                  size="small"
                  type="text"
                  @click="reject(scope.row)"
                  v-if="scope.row.applyState === 'wait'"
              >拒绝</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
            background
            :total="total"
            @current-change="paging"
            @size-change="handleSizeChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
        title="驳回备注"
        :visible="detailsVisible"
        @close="detailsVisible = false"
        custom-class="sales-volumn-dialog"
    >
      <el-form
          label-width="80px"
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
      >
        <el-form-item label="驳回原因" prop="refuseReason">
          <el-input
              maxlength="100"
              placeholder="请输入驳回原因，可直接选择下方模板"
              size="small"
              style="width: auto"
              type="textarea"
              v-model="ruleForm.applyResult"
          ></el-input>
        </el-form-item>
        <div class="reject-refuseReason">
          <el-radio-group
              v-model="rejectReason"
              @change="switchRejectReason"
          >
            <div v-for="(v, i) in rejectTemp" :key="i">
              <el-radio :label="i">{{ v }}</el-radio>
            </div>
          </el-radio-group>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center">
            <el-button
                @click="submitReject('ruleForm')"
                size="small"
                type="primary"
            >确认</el-button
            >
            <el-button @click="detailsVisible = false" size="small"
            >关闭</el-button
            >
          </span>
    </el-dialog>
  </hm-content>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {
        applyState: "wait",
        keyWord: "",
        applyDate: []
      },
      stateNum: {},
      rejectTemp: [
        "图片不清。",
        "人物图像不清晰或不完善。"
      ],
      detailsVisible: false,
      rejectReason: "",
      ruleForm: {
        applyResult: "",
      },
      rules: {},
    };
  },
  created() {},
  mounted() {
    this.queryStateNum();
    this.queryList();
  },
  methods: {
    async audit(row) {
      const result = await this.$confirm(`是否同意？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      if (result === "confirm") {
        let params = {
          applyState: "agree",
          id: row.id
        };
        this.submit(params);
      }
    },
    async submit(params) {
      await this.$store.dispatch("accountAppealAudit",params);
      this.$message({
        message: "操作成功!",
        type: "success"
      });
      this.queryStateNum();
      this.queryList();
    },
    switchTabs() {
      this.currentPage = 1;
      this.pageSize = 10;
      this.queryList();
    },
    async submitReject() {
      const valid = await this.$refs.ruleForm.validate();
      if (valid) {
        let params = {
          applyState: "refuse",
          id: this.row.id,
          applyResult: this.ruleForm.applyResult
        };
        await this.submit(params);

        this.detailsVisible = false;
        setTimeout(() => {
          this.resetRuleForm("ruleForm");
        }, 0);
      } else {
        return false;
      }
    },
    switchRejectReason() {
      this.ruleForm.applyResult = this.rejectTemp[this.rejectReason];
    },
    reject(row) {
      this.detailsVisible = true;
      this.row = row;
    },
    async queryStateNum() {
      const { result } = await this.$store.dispatch("queryAccountAppealStateNum");
      this.stateNum = result;
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      if ("all" == params.applyState) {
        params.applyState = "";
      }
      if (params.applyDate && params.applyDate.length == 2) {
        params.queryStartDate = params.applyDate[0];
        params.queryEndDate = params.applyDate[1];
      }
      const { code, result } = await this.$store.dispatch("queryAccountAppealList", params);
      if (code === "0") {
        const { total, records } = result;
        this.list = records;
        this.total = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
  },
};
</script>

<style scoped lang="scss">
</style>
